import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight, Search } from "lucide-react";
import { testimonials, propertySearch } from "../mock";

export const PropertySearch = () => {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {propertySearch.map((p) => (
          <Link
            key={p.city}
            to={`/apply-to-buy?area=${encodeURIComponent(p.city)}`}
            className="group bg-white border border-[#ece2d1] rounded-xl px-5 py-5 flex items-center justify-between hover-lift"
          >
            <div className="flex items-center gap-3">
              <Search className="w-4 h-4 text-gold" />
              <span className="text-sm md:text-[15px] text-[#141210] font-medium">
                {p.city}
              </span>
            </div>
            <ArrowRight className="w-4 h-4 text-[#c4b79f] group-hover:text-gold transition-colors" />
          </Link>
        ))}
      </div>
      <p className="text-center text-xs text-[#9a8f7d] mt-6">
        Pick your area and I'll personally send you matching listings — you'll always work directly
        with me, never a random agent.
      </p>
    </div>
  );
};

export const Testimonials = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
      {testimonials.map((t) => (
        <div
          key={t.name}
          className="bg-white rounded-2xl p-8 border border-[#efe6d6] hover-lift flex flex-col"
        >
          <div className="flex gap-1 mb-5">
            {Array.from({ length: t.rating }).map((_, s) => (
              <Star key={`${t.name}-star-${s}`} className="w-4 h-4 fill-[#d4af37] text-[#d4af37]" />
            ))}
          </div>
          <p className="font-display text-xl leading-relaxed text-[#3a332c] italic mb-6 flex-1">
            "{t.quote}"
          </p>
          <div>
            <div className="text-sm font-semibold text-[#141210]">{t.name}</div>
            <div className="text-xs tracking-wide uppercase text-gold mt-1">{t.role}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
